import { eq } from 'tio-ui/utilities';
import { fn } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import errorsForField from '../../../helpers/errors-for-field.ts';
import TuitionAssistanceProgramCustomFormField from '../program-custom-form-field.gts';
import type { CustomFieldSignature } from '../../../types/tuition-assistance.ts';
import type Owner from '@ember/owner';
import type TasProgramTemplateModel from 'tio-data/models/tas-program-template';

export interface ValidationErrorSignature {
  errors: string[];
  value: string;
  path: string;
}

export interface CustomFieldsForProvinceSignature {
  Args: {
    customFields: CustomFieldSignature[];
    didUpdateFields: (fields: CustomFieldSignature[], key?: string) => void;
    province: string;
    formValidationErrors: ValidationErrorSignature[];
    fieldContainerClass?: string;
    hasSubmitted?: boolean;
    customFieldModel?: string;
    programTemplate?: TasProgramTemplateModel;
  };
}

export default class CustomFieldsForProvinceComponent extends Component<CustomFieldsForProvinceSignature> {
  @tracked editableFields: CustomFieldSignature[] = [];

  constructor(owner: Owner, args: CustomFieldsForProvinceSignature['Args']) {
    super(owner, args);

    const fields = this.args.customFields || [];
    this.editableFields = fields
      .map((field) => {
        return { ...field };
      })
      .sort((a, b) => {
        return (a.ordinal ?? 0) - (b.ordinal ?? 0);
      });
  }

  updateFieldAtIndex = (index: number, value: CustomFieldSignature) => {
    this.editableFields[index] = value;
    if (this.args.customFieldModel) {
      this.args.didUpdateFields?.(this.editableFields, this.args.customFieldModel);
    }
    this.args.didUpdateFields?.(this.editableFields);
  };

  <template>
    {{#each this.editableFields as |field index|}}
      {{#if (eq field.province @province)}}
        <TuitionAssistanceProgramCustomFormField
          @field={{field}}
          @errors={{errorsForField field.label schemaErrors=@formValidationErrors}}
          @hasSubmitted={{@hasSubmitted}}
          @didUpdate={{fn this.updateFieldAtIndex index}}
          @programTemplate={{@programTemplate}}
          class={{@fieldContainerClass}}
        />
      {{/if}}
    {{/each}}
  </template>
}
